export const GET_CANDIDATE_INTERVIEW_DETAILS="GET_CANDIDATE_INTERVIEW_DETAILS"
export  const GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS="GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS"
export const GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE="GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE"
export const POST_CANDIDATE_STAGE="POST_CANDIDATE_STAGE";
export const POST_CANDIDATE_STAGE_SUCCESSFULL="POST_CANDIDATE_STAGE_SUCCESSFULL";
export const POST_CANDIDATE_STAGE_FAILURE="POST_CANDIDATE_STAGE_FAILURE";
export const GET_CURRENT_CANDIDATE_STATUS="GET_CURRENT_CANDIDATE_STATUS";
export const GET_CURRENT_CANDIDATE_STATUS_SUCCESSFULL="GET_CURRENT_CANDIDATE_STATUS_SUCCESSFULL";
export const GET_CURRENT_CANDIDATE_STATUS_FAILURE="GET_CURRENT_CANDIDATE_STATUS_FAILURE";
export const POST_CANDIDATE_FEEDBACK="POST_CANDIDATE_FEEDBACK";
export const POST_CANDIDATE_FEEDBACK_SUCCESSFULL="POST_CANDIDATE_FEEDBACK_SUCCESSFULL"
export const POST_CANDIDATE_FEEDBACK_FAILURE="POST_CANDIDATE_FEEDBACK_FAILURE"
export const GET_CANDIDATE_COMMENT_LIST="GET_CANDIDATE_COMMENT_LIST"
export const GET_CANDIDATE_COMMENT_LIST_SUCCESSFULL="GET_CANDIDATE_COMMENT_LIST_SUCCESSFULL"
export const GET_CANDIDATE_COMMENT_LIST_FAILURE="GET_CANDIDATE_COMMENT_LIST_FAILURE"
export const POST_COMMENT_ON_CANDIDATE="POST_COMMENT_ON_CANDIDATE"
export const POST_COMMENT_ON_CANDIDATE_SUCCESSFULL="POST_COMMENT_ON_CANDIDATE_SUCCESSFULL"
export const POST_COMMENT_ON_CANDIDATE_FAILURE="POST_COMMENT_ON_CANDIDATE_FAILURE"

//candidate mapping status change on recruitment page
export const UPDATE_CANDIDATE_MAPPING_STATUS="UPDATE_CANDIDATE_MAPPING_STATUS"
export const UPDATE_CANDIDATE_MAPPING_STATUS_SUCCESS="UPDATE_CANDIDATE_MAPPING_STATUS_SUCCESS"
export const UPDATE_CANDIDATE_MAPPING_STATUS_FAILED="UPDATE_CANDIDATE_MAPPING_STATUS_FAILED"

